module.exports = __webpack_public_path__ + "img/about.6a86825e.svg";